/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AccountsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Promise<LicenceAccount[]> {
        let url_ = this.baseUrl + "/api/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<LicenceAccount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenceAccount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenceAccount[]>(<any>null);
    }

    post(account: LicenceAccount): Promise<LicenceAccount> {
        let url_ = this.baseUrl + "/api/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(account);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<LicenceAccount> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceAccount.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenceAccount>(<any>null);
    }

    put(id: number | undefined, account: LicenceAccount): Promise<LicenceAccount> {
        let url_ = this.baseUrl + "/api/accounts?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(account);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<LicenceAccount> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceAccount.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenceAccount>(<any>null);
    }

    delete(id: number | undefined): Promise<LicenceAccount> {
        let url_ = this.baseUrl + "/api/accounts?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<LicenceAccount> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceAccount.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenceAccount>(<any>null);
    }

    get(id: number): Promise<LicenceAccount> {
        let url_ = this.baseUrl + "/api/accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<LicenceAccount> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceAccount.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenceAccount>(<any>null);
    }
}

export class AlarmsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<ConfiguredAlarm[]> {
        let url_ = this.baseUrl + "/api/alarms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ConfiguredAlarm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfiguredAlarm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfiguredAlarm[]>(<any>null);
    }

    delete(id: number | undefined): Promise<Alarm> {
        let url_ = this.baseUrl + "/api/alarms?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<Alarm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Alarm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Alarm>(<any>null);
    }

    post(configuredAlarm: ConfiguredAlarm): Promise<ConfiguredAlarm> {
        let url_ = this.baseUrl + "/api/alarms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configuredAlarm);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<ConfiguredAlarm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfiguredAlarm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfiguredAlarm>(<any>null);
    }

    put(id: number | undefined, configuredAlarm: ConfiguredAlarm): Promise<ConfiguredAlarm> {
        let url_ = this.baseUrl + "/api/alarms?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configuredAlarm);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<ConfiguredAlarm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfiguredAlarm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfiguredAlarm>(<any>null);
    }
}

export class ContactsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<NotificationContact[]> {
        let url_ = this.baseUrl + "/api/contacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<NotificationContact[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationContact.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationContact[]>(<any>null);
    }

    post(contact: NotificationContact): Promise<NotificationContact> {
        let url_ = this.baseUrl + "/api/contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contact);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<NotificationContact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationContact.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationContact>(<any>null);
    }

    put(id: number | undefined, contact: NotificationContact): Promise<NotificationContact> {
        let url_ = this.baseUrl + "/api/contacts?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contact);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<NotificationContact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationContact.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationContact>(<any>null);
    }

    delete(id: number | undefined): Promise<NotificationContact> {
        let url_ = this.baseUrl + "/api/contacts?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<NotificationContact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationContact.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationContact>(<any>null);
    }
}

export class EntryPointArgsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<EntryPointArgs> {
        let url_ = this.baseUrl + "/api/entrypointargs/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<EntryPointArgs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntryPointArgs.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntryPointArgs>(<any>null);
    }
}

export class EvaluationsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(completed: boolean | undefined, limit: number | undefined): Promise<EvaluationRun[]> {
        let url_ = this.baseUrl + "/api/evaluations?";
        if (completed === null)
            throw new Error("The parameter 'completed' cannot be null.");
        else if (completed !== undefined)
            url_ += "completed=" + encodeURIComponent("" + completed) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<EvaluationRun[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EvaluationRun.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvaluationRun[]>(<any>null);
    }

    post(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/evaluations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    get(id: string): Promise<EvaluationRun> {
        let url_ = this.baseUrl + "/api/evaluations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<EvaluationRun> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EvaluationRun.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvaluationRun>(<any>null);
    }
}

export class HistoricalApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(from: Date | undefined, to: Date | undefined): Promise<HistoricalReportRow[]> {
        let url_ = this.baseUrl + "/api/historical?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<HistoricalReportRow[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HistoricalReportRow.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoricalReportRow[]>(<any>null);
    }
}

export class IntegrationsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<NotificationWebhook[]> {
        let url_ = this.baseUrl + "/api/integrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<NotificationWebhook[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationWebhook.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationWebhook[]>(<any>null);
    }

    postWebhook(req: WebhookIntegration): Promise<WebhookIntegration> {
        let url_ = this.baseUrl + "/api/integrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostWebhook(_response);
        });
    }

    protected processPostWebhook(response: Response): Promise<WebhookIntegration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookIntegration.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebhookIntegration>(<any>null);
    }

    delete(id: number | undefined): Promise<WebhookIntegration> {
        let url_ = this.baseUrl + "/api/integrations?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<WebhookIntegration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookIntegration.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebhookIntegration>(<any>null);
    }

    postSlackToken(req: SlackTokenRequest): Promise<WebhookIntegration> {
        let url_ = this.baseUrl + "/api/integrations/slack";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostSlackToken(_response);
        });
    }

    protected processPostSlackToken(response: Response): Promise<WebhookIntegration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookIntegration.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebhookIntegration>(<any>null);
    }
}

export class RulesApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(l: number | null | undefined): Promise<RuleData> {
        let url_ = this.baseUrl + "/api/rules?";
        if (l !== undefined && l !== null)
            url_ += "l=" + encodeURIComponent("" + l) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<RuleData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RuleData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RuleData>(<any>null);
    }
}

export class SelfAccountApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<LicenceAccount> {
        let url_ = this.baseUrl + "/api/self";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<LicenceAccount> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceAccount.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenceAccount>(<any>null);
    }
}

export class ClientAuthenticationApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getJavaScriptClient(): Promise<JavaScriptClientDto> {
        let url_ = this.baseUrl + "/api/authentication/javascript-client";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJavaScriptClient(_response);
        });
    }

    protected processGetJavaScriptClient(response: Response): Promise<JavaScriptClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JavaScriptClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JavaScriptClientDto>(<any>null);
    }
}

export class ClientAuthorisationApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    isAuthorised(policies: string[] | null | undefined): Promise<IsAuthorisedDto> {
        let url_ = this.baseUrl + "/api/authorisation/is-authorised?";
        if (policies !== undefined && policies !== null)
            policies && policies.forEach(item => { url_ += "policies=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsAuthorised(_response);
        });
    }

    protected processIsAuthorised(response: Response): Promise<IsAuthorisedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsAuthorisedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IsAuthorisedDto>(<any>null);
    }
}

export class LicenceAccount implements ILicenceAccount {
    id?: number;
    licenceId?: number;
    credits?: number;
    addressBookLimit?: number;
    comment?: string | undefined;
    enabled?: boolean;
    mappingId?: string | undefined;
    heartbeatUrl?: string | undefined;
    heartbeatHeaders?: string | undefined;

    constructor(data?: ILicenceAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenceId = _data["licenceId"];
            this.credits = _data["credits"];
            this.addressBookLimit = _data["addressBookLimit"];
            this.comment = _data["comment"];
            this.enabled = _data["enabled"];
            this.mappingId = _data["mappingId"];
            this.heartbeatUrl = _data["heartbeatUrl"];
            this.heartbeatHeaders = _data["heartbeatHeaders"];
        }
    }

    static fromJS(data: any): LicenceAccount {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenceId"] = this.licenceId;
        data["credits"] = this.credits;
        data["addressBookLimit"] = this.addressBookLimit;
        data["comment"] = this.comment;
        data["enabled"] = this.enabled;
        data["mappingId"] = this.mappingId;
        data["heartbeatUrl"] = this.heartbeatUrl;
        data["heartbeatHeaders"] = this.heartbeatHeaders;
        return data;
    }
}

export interface ILicenceAccount {
    id?: number;
    licenceId?: number;
    credits?: number;
    addressBookLimit?: number;
    comment?: string | undefined;
    enabled?: boolean;
    mappingId?: string | undefined;
    heartbeatUrl?: string | undefined;
    heartbeatHeaders?: string | undefined;
}

export class ConfiguredAlarm implements IConfiguredAlarm {
    id?: number;
    name?: string | undefined;
    message?: string | undefined;
    origin?: string | undefined;
    selectedDataType?: DataType | undefined;
    selectedEntity?: Entity | undefined;
    selectedRuleCheck?: RuleCheck | undefined;
    ruleValue?: string | undefined;
    contacts?: NotificationContact[] | undefined;
    webhooks?: NotificationWebhook[] | undefined;

    constructor(data?: IConfiguredAlarm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.message = _data["message"];
            this.origin = _data["origin"];
            this.selectedDataType = _data["selectedDataType"] ? DataType.fromJS(_data["selectedDataType"]) : <any>undefined;
            this.selectedEntity = _data["selectedEntity"] ? Entity.fromJS(_data["selectedEntity"]) : <any>undefined;
            this.selectedRuleCheck = _data["selectedRuleCheck"] ? RuleCheck.fromJS(_data["selectedRuleCheck"]) : <any>undefined;
            this.ruleValue = _data["ruleValue"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(NotificationContact.fromJS(item));
            }
            if (Array.isArray(_data["webhooks"])) {
                this.webhooks = [] as any;
                for (let item of _data["webhooks"])
                    this.webhooks!.push(NotificationWebhook.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfiguredAlarm {
        data = typeof data === 'object' ? data : {};
        let result = new ConfiguredAlarm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["message"] = this.message;
        data["origin"] = this.origin;
        data["selectedDataType"] = this.selectedDataType ? this.selectedDataType.toJSON() : <any>undefined;
        data["selectedEntity"] = this.selectedEntity ? this.selectedEntity.toJSON() : <any>undefined;
        data["selectedRuleCheck"] = this.selectedRuleCheck ? this.selectedRuleCheck.toJSON() : <any>undefined;
        data["ruleValue"] = this.ruleValue;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.webhooks)) {
            data["webhooks"] = [];
            for (let item of this.webhooks)
                data["webhooks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfiguredAlarm {
    id?: number;
    name?: string | undefined;
    message?: string | undefined;
    origin?: string | undefined;
    selectedDataType?: DataType | undefined;
    selectedEntity?: Entity | undefined;
    selectedRuleCheck?: RuleCheck | undefined;
    ruleValue?: string | undefined;
    contacts?: NotificationContact[] | undefined;
    webhooks?: NotificationWebhook[] | undefined;
}

export class DataType implements IDataType {
    id?: number;
    name?: string | undefined;
    units?: string | undefined;
    format?: string | undefined;
    isPrivate?: boolean;
    variableType?: string | undefined;

    constructor(data?: IDataType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.units = _data["units"];
            this.format = _data["format"];
            this.isPrivate = _data["isPrivate"];
            this.variableType = _data["variableType"];
        }
    }

    static fromJS(data: any): DataType {
        data = typeof data === 'object' ? data : {};
        let result = new DataType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["units"] = this.units;
        data["format"] = this.format;
        data["isPrivate"] = this.isPrivate;
        data["variableType"] = this.variableType;
        return data;
    }
}

export interface IDataType {
    id?: number;
    name?: string | undefined;
    units?: string | undefined;
    format?: string | undefined;
    isPrivate?: boolean;
    variableType?: string | undefined;
}

export class Entity implements IEntity {
    id?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    entityType?: string | undefined;

    constructor(data?: IEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.entityType = _data["entityType"];
        }
    }

    static fromJS(data: any): Entity {
        data = typeof data === 'object' ? data : {};
        let result = new Entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["entityType"] = this.entityType;
        return data;
    }
}

export interface IEntity {
    id?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    entityType?: string | undefined;
}

export class RuleCheck implements IRuleCheck {
    id?: number;
    name?: string | undefined;
    symbol?: string | undefined;
    alarmType?: string | undefined;
    isNumeric?: boolean;

    constructor(data?: IRuleCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.symbol = _data["symbol"];
            this.alarmType = _data["alarmType"];
            this.isNumeric = _data["isNumeric"];
        }
    }

    static fromJS(data: any): RuleCheck {
        data = typeof data === 'object' ? data : {};
        let result = new RuleCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["symbol"] = this.symbol;
        data["alarmType"] = this.alarmType;
        data["isNumeric"] = this.isNumeric;
        return data;
    }
}

export interface IRuleCheck {
    id?: number;
    name?: string | undefined;
    symbol?: string | undefined;
    alarmType?: string | undefined;
    isNumeric?: boolean;
}

export class NotificationContact implements INotificationContact {
    id?: number;
    licenceAccountId?: number;
    mobileNumber?: string | undefined;
    name?: string | undefined;

    constructor(data?: INotificationContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenceAccountId = _data["licenceAccountId"];
            this.mobileNumber = _data["mobileNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): NotificationContact {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenceAccountId"] = this.licenceAccountId;
        data["mobileNumber"] = this.mobileNumber;
        data["name"] = this.name;
        return data;
    }
}

export interface INotificationContact {
    id?: number;
    licenceAccountId?: number;
    mobileNumber?: string | undefined;
    name?: string | undefined;
}

export class NotificationWebhook implements INotificationWebhook {
    id?: number;
    licenceAccountId?: number;
    name?: string | undefined;
    webhookUrl?: string | undefined;

    constructor(data?: INotificationWebhook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenceAccountId = _data["licenceAccountId"];
            this.name = _data["name"];
            this.webhookUrl = _data["webhookUrl"];
        }
    }

    static fromJS(data: any): NotificationWebhook {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationWebhook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenceAccountId"] = this.licenceAccountId;
        data["name"] = this.name;
        data["webhookUrl"] = this.webhookUrl;
        return data;
    }
}

export interface INotificationWebhook {
    id?: number;
    licenceAccountId?: number;
    name?: string | undefined;
    webhookUrl?: string | undefined;
}

export class Alarm implements IAlarm {
    id?: number;
    name?: string | undefined;
    message?: string | undefined;
    origin?: string | undefined;
    ruleType?: AlarmRuleType | undefined;
    ruleVariableType?: string | undefined;
    ruleVariable?: string | undefined;
    alarmRuleEvaluationState?: AlarmEvaluationState | undefined;
    licenceAccount?: LicenceAccount | undefined;
    phoneNumbers?: AlarmPhoneNumber[] | undefined;
    webhooks?: AlarmWebhook[] | undefined;

    constructor(data?: IAlarm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.message = _data["message"];
            this.origin = _data["origin"];
            this.ruleType = _data["ruleType"] ? AlarmRuleType.fromJS(_data["ruleType"]) : <any>undefined;
            this.ruleVariableType = _data["ruleVariableType"];
            this.ruleVariable = _data["ruleVariable"];
            this.alarmRuleEvaluationState = _data["alarmRuleEvaluationState"] ? AlarmEvaluationState.fromJS(_data["alarmRuleEvaluationState"]) : <any>undefined;
            this.licenceAccount = _data["licenceAccount"] ? LicenceAccount.fromJS(_data["licenceAccount"]) : <any>undefined;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(AlarmPhoneNumber.fromJS(item));
            }
            if (Array.isArray(_data["webhooks"])) {
                this.webhooks = [] as any;
                for (let item of _data["webhooks"])
                    this.webhooks!.push(AlarmWebhook.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Alarm {
        data = typeof data === 'object' ? data : {};
        let result = new Alarm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["message"] = this.message;
        data["origin"] = this.origin;
        data["ruleType"] = this.ruleType ? this.ruleType.toJSON() : <any>undefined;
        data["ruleVariableType"] = this.ruleVariableType;
        data["ruleVariable"] = this.ruleVariable;
        data["alarmRuleEvaluationState"] = this.alarmRuleEvaluationState ? this.alarmRuleEvaluationState.toJSON() : <any>undefined;
        data["licenceAccount"] = this.licenceAccount ? this.licenceAccount.toJSON() : <any>undefined;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.webhooks)) {
            data["webhooks"] = [];
            for (let item of this.webhooks)
                data["webhooks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlarm {
    id?: number;
    name?: string | undefined;
    message?: string | undefined;
    origin?: string | undefined;
    ruleType?: AlarmRuleType | undefined;
    ruleVariableType?: string | undefined;
    ruleVariable?: string | undefined;
    alarmRuleEvaluationState?: AlarmEvaluationState | undefined;
    licenceAccount?: LicenceAccount | undefined;
    phoneNumbers?: AlarmPhoneNumber[] | undefined;
    webhooks?: AlarmWebhook[] | undefined;
}

export class AlarmRuleType implements IAlarmRuleType {
    id?: string | undefined;
    sql?: string | undefined;
    dataType?: DataType | undefined;
    entity?: Entity | undefined;
    ruleCheck?: RuleCheck | undefined;

    constructor(data?: IAlarmRuleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sql = _data["sql"];
            this.dataType = _data["dataType"] ? DataType.fromJS(_data["dataType"]) : <any>undefined;
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : <any>undefined;
            this.ruleCheck = _data["ruleCheck"] ? RuleCheck.fromJS(_data["ruleCheck"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlarmRuleType {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmRuleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sql"] = this.sql;
        data["dataType"] = this.dataType ? this.dataType.toJSON() : <any>undefined;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["ruleCheck"] = this.ruleCheck ? this.ruleCheck.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAlarmRuleType {
    id?: string | undefined;
    sql?: string | undefined;
    dataType?: DataType | undefined;
    entity?: Entity | undefined;
    ruleCheck?: RuleCheck | undefined;
}

export class AlarmEvaluationState implements IAlarmEvaluationState {
    alarmId?: number;
    version?: number;
    alarm?: Alarm | undefined;

    constructor(data?: IAlarmEvaluationState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alarmId = _data["alarmId"];
            this.version = _data["version"];
            this.alarm = _data["alarm"] ? Alarm.fromJS(_data["alarm"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlarmEvaluationState {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmEvaluationState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmId"] = this.alarmId;
        data["version"] = this.version;
        data["alarm"] = this.alarm ? this.alarm.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAlarmEvaluationState {
    alarmId?: number;
    version?: number;
    alarm?: Alarm | undefined;
}

export class AlarmPhoneNumber implements IAlarmPhoneNumber {
    alarmId?: number;
    phoneNumberId?: number;
    alarm?: Alarm | undefined;
    phoneNumber?: PhoneNumber | undefined;

    constructor(data?: IAlarmPhoneNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alarmId = _data["alarmId"];
            this.phoneNumberId = _data["phoneNumberId"];
            this.alarm = _data["alarm"] ? Alarm.fromJS(_data["alarm"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"] ? PhoneNumber.fromJS(_data["phoneNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlarmPhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmPhoneNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmId"] = this.alarmId;
        data["phoneNumberId"] = this.phoneNumberId;
        data["alarm"] = this.alarm ? this.alarm.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber ? this.phoneNumber.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAlarmPhoneNumber {
    alarmId?: number;
    phoneNumberId?: number;
    alarm?: Alarm | undefined;
    phoneNumber?: PhoneNumber | undefined;
}

export class PhoneNumber implements IPhoneNumber {
    id?: number;
    licenceAccountId?: number;
    mobileNumber?: string | undefined;
    name?: string | undefined;
    licenceAccount?: LicenceAccount | undefined;
    alarms?: AlarmPhoneNumber[] | undefined;

    constructor(data?: IPhoneNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenceAccountId = _data["licenceAccountId"];
            this.mobileNumber = _data["mobileNumber"];
            this.name = _data["name"];
            this.licenceAccount = _data["licenceAccount"] ? LicenceAccount.fromJS(_data["licenceAccount"]) : <any>undefined;
            if (Array.isArray(_data["alarms"])) {
                this.alarms = [] as any;
                for (let item of _data["alarms"])
                    this.alarms!.push(AlarmPhoneNumber.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenceAccountId"] = this.licenceAccountId;
        data["mobileNumber"] = this.mobileNumber;
        data["name"] = this.name;
        data["licenceAccount"] = this.licenceAccount ? this.licenceAccount.toJSON() : <any>undefined;
        if (Array.isArray(this.alarms)) {
            data["alarms"] = [];
            for (let item of this.alarms)
                data["alarms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPhoneNumber {
    id?: number;
    licenceAccountId?: number;
    mobileNumber?: string | undefined;
    name?: string | undefined;
    licenceAccount?: LicenceAccount | undefined;
    alarms?: AlarmPhoneNumber[] | undefined;
}

export class AlarmWebhook implements IAlarmWebhook {
    alarmId?: number;
    webhookId?: number;
    alarm?: Alarm | undefined;
    webhook?: WebhookIntegration | undefined;

    constructor(data?: IAlarmWebhook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alarmId = _data["alarmId"];
            this.webhookId = _data["webhookId"];
            this.alarm = _data["alarm"] ? Alarm.fromJS(_data["alarm"]) : <any>undefined;
            this.webhook = _data["webhook"] ? WebhookIntegration.fromJS(_data["webhook"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlarmWebhook {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmWebhook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmId"] = this.alarmId;
        data["webhookId"] = this.webhookId;
        data["alarm"] = this.alarm ? this.alarm.toJSON() : <any>undefined;
        data["webhook"] = this.webhook ? this.webhook.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAlarmWebhook {
    alarmId?: number;
    webhookId?: number;
    alarm?: Alarm | undefined;
    webhook?: WebhookIntegration | undefined;
}

export class WebhookIntegration implements IWebhookIntegration {
    id?: number;
    licenceAccountId?: number;
    licenceAccount?: LicenceAccount | undefined;
    alarms?: AlarmWebhook[] | undefined;
    slackTeamName?: string | undefined;
    slackChannel?: string | undefined;
    slackChannelId?: string | undefined;
    slackConfigurationUrl?: string | undefined;
    name?: string | undefined;
    webhookUrl?: string | undefined;

    constructor(data?: IWebhookIntegration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenceAccountId = _data["licenceAccountId"];
            this.licenceAccount = _data["licenceAccount"] ? LicenceAccount.fromJS(_data["licenceAccount"]) : <any>undefined;
            if (Array.isArray(_data["alarms"])) {
                this.alarms = [] as any;
                for (let item of _data["alarms"])
                    this.alarms!.push(AlarmWebhook.fromJS(item));
            }
            this.slackTeamName = _data["slackTeamName"];
            this.slackChannel = _data["slackChannel"];
            this.slackChannelId = _data["slackChannelId"];
            this.slackConfigurationUrl = _data["slackConfigurationUrl"];
            this.name = _data["name"];
            this.webhookUrl = _data["webhookUrl"];
        }
    }

    static fromJS(data: any): WebhookIntegration {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookIntegration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenceAccountId"] = this.licenceAccountId;
        data["licenceAccount"] = this.licenceAccount ? this.licenceAccount.toJSON() : <any>undefined;
        if (Array.isArray(this.alarms)) {
            data["alarms"] = [];
            for (let item of this.alarms)
                data["alarms"].push(item.toJSON());
        }
        data["slackTeamName"] = this.slackTeamName;
        data["slackChannel"] = this.slackChannel;
        data["slackChannelId"] = this.slackChannelId;
        data["slackConfigurationUrl"] = this.slackConfigurationUrl;
        data["name"] = this.name;
        data["webhookUrl"] = this.webhookUrl;
        return data;
    }
}

export interface IWebhookIntegration {
    id?: number;
    licenceAccountId?: number;
    licenceAccount?: LicenceAccount | undefined;
    alarms?: AlarmWebhook[] | undefined;
    slackTeamName?: string | undefined;
    slackChannel?: string | undefined;
    slackChannelId?: string | undefined;
    slackConfigurationUrl?: string | undefined;
    name?: string | undefined;
    webhookUrl?: string | undefined;
}

export class EntryPointArgs implements IEntryPointArgs {
    showAppBar!: boolean;

    constructor(data?: IEntryPointArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showAppBar = _data["showAppBar"];
        }
    }

    static fromJS(data: any): EntryPointArgs {
        data = typeof data === 'object' ? data : {};
        let result = new EntryPointArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showAppBar"] = this.showAppBar;
        return data;
    }
}

export interface IEntryPointArgs {
    showAppBar: boolean;
}

export class EvaluationRun implements IEvaluationRun {
    id?: string | undefined;
    evaluationStartTime?: Date;
    evaluationCompleteTime?: Date | undefined;
    errorCount?: number | undefined;

    constructor(data?: IEvaluationRun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.evaluationStartTime = _data["evaluationStartTime"] ? new Date(_data["evaluationStartTime"].toString()) : <any>undefined;
            this.evaluationCompleteTime = _data["evaluationCompleteTime"] ? new Date(_data["evaluationCompleteTime"].toString()) : <any>undefined;
            this.errorCount = _data["errorCount"];
        }
    }

    static fromJS(data: any): EvaluationRun {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationRun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["evaluationStartTime"] = this.evaluationStartTime ? this.evaluationStartTime.toISOString() : <any>undefined;
        data["evaluationCompleteTime"] = this.evaluationCompleteTime ? this.evaluationCompleteTime.toISOString() : <any>undefined;
        data["errorCount"] = this.errorCount;
        return data;
    }
}

export interface IEvaluationRun {
    id?: string | undefined;
    evaluationStartTime?: Date;
    evaluationCompleteTime?: Date | undefined;
    errorCount?: number | undefined;
}

export class HistoricalReportRow implements IHistoricalReportRow {
    accountId?: number;
    alarmId?: number;
    accountName?: string | undefined;
    alarmName?: string | undefined;
    countTriggered?: number;

    constructor(data?: IHistoricalReportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.alarmId = _data["alarmId"];
            this.accountName = _data["accountName"];
            this.alarmName = _data["alarmName"];
            this.countTriggered = _data["countTriggered"];
        }
    }

    static fromJS(data: any): HistoricalReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["alarmId"] = this.alarmId;
        data["accountName"] = this.accountName;
        data["alarmName"] = this.alarmName;
        data["countTriggered"] = this.countTriggered;
        return data;
    }
}

export interface IHistoricalReportRow {
    accountId?: number;
    alarmId?: number;
    accountName?: string | undefined;
    alarmName?: string | undefined;
    countTriggered?: number;
}

export class SlackTokenRequest implements ISlackTokenRequest {
    code?: string | undefined;
    state?: string | undefined;

    constructor(data?: ISlackTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): SlackTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SlackTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["state"] = this.state;
        return data;
    }
}

export interface ISlackTokenRequest {
    code?: string | undefined;
    state?: string | undefined;
}

export class RuleData implements IRuleData {
    relations?: RuleRelation[] | undefined;
    dataTypes?: DataType[] | undefined;
    entities?: Entity[] | undefined;
    ruleChecks?: RuleCheck[] | undefined;

    constructor(data?: IRuleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["relations"])) {
                this.relations = [] as any;
                for (let item of _data["relations"])
                    this.relations!.push(RuleRelation.fromJS(item));
            }
            if (Array.isArray(_data["dataTypes"])) {
                this.dataTypes = [] as any;
                for (let item of _data["dataTypes"])
                    this.dataTypes!.push(DataType.fromJS(item));
            }
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(Entity.fromJS(item));
            }
            if (Array.isArray(_data["ruleChecks"])) {
                this.ruleChecks = [] as any;
                for (let item of _data["ruleChecks"])
                    this.ruleChecks!.push(RuleCheck.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RuleData {
        data = typeof data === 'object' ? data : {};
        let result = new RuleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.relations)) {
            data["relations"] = [];
            for (let item of this.relations)
                data["relations"].push(item.toJSON());
        }
        if (Array.isArray(this.dataTypes)) {
            data["dataTypes"] = [];
            for (let item of this.dataTypes)
                data["dataTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        if (Array.isArray(this.ruleChecks)) {
            data["ruleChecks"] = [];
            for (let item of this.ruleChecks)
                data["ruleChecks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRuleData {
    relations?: RuleRelation[] | undefined;
    dataTypes?: DataType[] | undefined;
    entities?: Entity[] | undefined;
    ruleChecks?: RuleCheck[] | undefined;
}

export class RuleRelation implements IRuleRelation {
    ruleId?: string | undefined;
    dataTypeId?: number;
    entityId?: string | undefined;
    ruleCheckId?: number;

    constructor(data?: IRuleRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleId = _data["ruleId"];
            this.dataTypeId = _data["dataTypeId"];
            this.entityId = _data["entityId"];
            this.ruleCheckId = _data["ruleCheckId"];
        }
    }

    static fromJS(data: any): RuleRelation {
        data = typeof data === 'object' ? data : {};
        let result = new RuleRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleId"] = this.ruleId;
        data["dataTypeId"] = this.dataTypeId;
        data["entityId"] = this.entityId;
        data["ruleCheckId"] = this.ruleCheckId;
        return data;
    }
}

export interface IRuleRelation {
    ruleId?: string | undefined;
    dataTypeId?: number;
    entityId?: string | undefined;
    ruleCheckId?: number;
}

export class JavaScriptClientDto implements IJavaScriptClientDto {
    authority!: string;
    clientId!: string;
    redirectUrl!: string;
    silentRedirectUrl!: string;
    responseType!: string;
    scope!: string;
    postLogoutRedirectUrl!: string;

    constructor(data?: IJavaScriptClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authority = _data["authority"];
            this.clientId = _data["clientId"];
            this.redirectUrl = _data["redirectUrl"];
            this.silentRedirectUrl = _data["silentRedirectUrl"];
            this.responseType = _data["responseType"];
            this.scope = _data["scope"];
            this.postLogoutRedirectUrl = _data["postLogoutRedirectUrl"];
        }
    }

    static fromJS(data: any): JavaScriptClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new JavaScriptClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authority"] = this.authority;
        data["clientId"] = this.clientId;
        data["redirectUrl"] = this.redirectUrl;
        data["silentRedirectUrl"] = this.silentRedirectUrl;
        data["responseType"] = this.responseType;
        data["scope"] = this.scope;
        data["postLogoutRedirectUrl"] = this.postLogoutRedirectUrl;
        return data;
    }
}

export interface IJavaScriptClientDto {
    authority: string;
    clientId: string;
    redirectUrl: string;
    silentRedirectUrl: string;
    responseType: string;
    scope: string;
    postLogoutRedirectUrl: string;
}

export class IsAuthorisedDto implements IIsAuthorisedDto {
    isAuthorised!: boolean;

    constructor(data?: IIsAuthorisedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthorised = _data["isAuthorised"];
        }
    }

    static fromJS(data: any): IsAuthorisedDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsAuthorisedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthorised"] = this.isAuthorised;
        return data;
    }
}

export interface IIsAuthorisedDto {
    isAuthorised: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}